import React from "react";
import { useApplication } from "@/contexts/ApplicationContext";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardFooter,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import { CalendarCheck, Check, RefreshCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";

const OrientationConfirmation = () => {
  const { application } = useApplication();
  const navigate = useNavigate();
  const orientationDate = application.orientation.date
    ? new Date(application.orientation.date)
    : null;

  const handleReschedule = () => {
    navigate("/orientation");
  };

  const handleContinue = () => {
    navigate("/orientation-quiz");
  };

  return (
    <div className="max-w-md mx-auto">
      <Card>
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="rounded-full bg-green-100 p-3">
              <CalendarCheck className="h-8 w-8 text-green-600" />
            </div>
          </div>
          <CardTitle className="text-xl font-bold text-jungle mb-2">
            See You Soon!
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-gray-50 p-4 rounded-lg space-y-2">
            <h3 className="font-medium mb-2">Your Orientation Details</h3>
            {orientationDate && (
              <>
                <p className="text-sm">
                  <span className="font-medium">Date:</span>{" "}
                  {format(orientationDate, "EEEE, MMMM d, yyyy")}
                </p>
                <p className="text-sm">
                  <span className="font-medium">Time:</span>{" "}
                  {format(orientationDate, "h:mm a")}
                </p>
              </>
            )}
            {console.log(application)}
            <p className="text-sm">
              <span className="font-medium">Location:</span>{" "}
              {application.orientation.location
                ? `${application.orientation.location}`
                : "HIVED Orientation Center"}
            </p>
          </div>
          <p className="text-sm text-gray-600 text-center">
            We look forward to meeting you! Don't forget to bring your driving
            license and right to work documents.
          </p>
        </CardContent>
        <CardFooter className="flex flex-col justify-center pt-4 gap-2">
          <div className="flex justify-center">
            <Button
              variant="outline"
              onClick={handleReschedule}
              className="flex items-center gap-2"
            >
              <RefreshCcw className="h-4 w-4" />
              Reschedule Orientation
            </Button>
          </div>
          <div className="flex justify-center">
            <Button
              variant="outline"
              onClick={handleContinue}
              className="flex items-center gap-2"
            >
              <Check className="h-4 w-4" />I have attended orientation, Continue
            </Button>
          </div>
        </CardFooter>
      </Card>
    </div>
  );
};

export default OrientationConfirmation;
